import { render, staticRenderFns } from "./ModalEditDataWaskat2.vue?vue&type=template&id=6c8b0f17&lang=pug&"
import script from "./ModalEditDataWaskat2.vue?vue&type=script&lang=js&"
export * from "./ModalEditDataWaskat2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports